let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("3yMqM")]).then(() => parcelRequire('cEFZC'));